import { render, staticRenderFns } from "./Administradoras.vue?vue&type=template&id=61a3cd98&scoped=true&"
import script from "./administradoras.js?vue&type=script&lang=js&"
export * from "./administradoras.js?vue&type=script&lang=js&"
import style0 from "./Administradoras.vue?vue&type=style&index=0&id=61a3cd98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a3cd98",
  null
  
)

export default component.exports